import EditName from './edit_name'
import { reduxForm } from 'redux-form'
import { length, required, combine } from 'lib/validators'
import formUtils from 'lib/form_utils'
import { TITLE_LENGTH } from 'shared/lengths'
import { getI18n } from 'client/i18n'
import { updateRemotely } from 'redux/modules/campaign'
import { getCampaignSelector } from 'redux/selectors/campaign'

const i18n = getI18n('components/edit_glimpse/edit_name')

const mapStateToProps = (state, props) => {
  const campaign = getCampaignSelector(state, props)
  return {
    operatingRemotely: campaign.operatingRemotely,
    initialValues: {
      title: campaign.title,
    },
    campaignType: campaign.campaign_type,
  }
}

const mapDispatchToProps = (dispatch, { campaignId }) => {
  return {
    onSave(formValues) {
      return dispatch(updateRemotely(campaignId, { title: formValues.title }))
    },
  }
}

const validate = combine(
  length('title', TITLE_LENGTH, i18n('pool_name_too_long')),
  required('title', i18n('pool_name_is_required'))
)

export default reduxForm(
  {
    form: 'edit_name',
    fields: ['title'],
    validate,
    touchOnChange: true,
  },
  mapStateToProps,
  mapDispatchToProps
)(formUtils(EditName))
